export const scrollToSection = (id: string,animate:boolean) => {
    const section = document.getElementById(id);
  
    if (section) {
      window.scrollTo({
        top: section.offsetTop - 112,
        behavior: animate ? "smooth" : "auto"
      });
    }
  };